import libmime from 'libmime';
import trim from 'lodash/trim';

export default function(hdr) {
  let results = [];
  let addresses = [];
  let tokens = [];
  let thistoken = '';

  if (!hdr) {
    return [];
  }

  for (let i = 0; i < hdr.length; i++) {
    let ch = hdr.charAt(i);
    if (ch === '"') {
      thistoken = '';
      for (i++; i < hdr.length; i++) {
        ch = hdr.charAt(i);
        if (ch === '\\') {
          thistoken += hdr.charAt(++i);
        } else if (ch === '"') {
          break;
        } else {
          thistoken += ch;
        }
      }
      tokens.push(thistoken);
    } else if (ch === '<') {
      thistoken = '';
      for (; i < hdr.length; i++) {
        ch = hdr.charAt(i);
        if (ch === '>') {
          break;
        } else {
          thistoken += ch;
        }
      }
      tokens.push(thistoken + '>');
    } else if (ch === '(') {
      let commentDepth = 1;
      thistoken = '(';
      for (i++; i < hdr.length; i++) {
        ch = hdr.charAt(i);
        if (ch === '\\') {
          thistoken += hdr.charAt(++i);
        } else if (ch === '(') {
          commentDepth++;
        } else if (ch === ')') {
          commentDepth--;
          if (commentDepth === 0) {
            break;
          }
        } else {
          thistoken += ch;
        }
      }
      tokens.push(thistoken);
    } else if (ch === ',') {
      addresses.push(tokens);
      tokens = [];
    } else {
      tokens.push(ch);
    }
  }
  if (tokens.length > 0) {
    addresses.push(tokens);
  }
  console.log(addresses);
  for (let i = 0; i < addresses.length; i++) {
    let r = { name: '', addr: '' };

    for (let j = 0; j < addresses[i].length; j++) {
      if (addresses[i][j].substr(0, 1) === '<') {
        r.addr = addresses[i][j].substr(1, addresses[i][j].length - 2);
      } else {
        if (addresses[i][j].substr(0, 1) !== '(') {
          r.name += addresses[i][j];
        }
      }
    }
    if (r.addr === '') { // no angle-addr so use 'comments' method
      r.name = '';
      for (let j = 0; j < addresses[i].length; j++) {
        if (addresses[i][j].substr(0, 1) === '(') {
          r.name += addresses[i][j].substr(1);
        } else if (addresses[i][j] !== ' ') {
          r.addr += addresses[i][j];
        }
      }
    }
    console.log(r);
    r.name = trim(libmime.decodeWords(r.name));
    r.addr = trim(r.addr);
    r.nameAuto = false;
    if (r.name === '') {
      r.name = r.addr;
      r.nameAuto = true;
    }
    const m = /^([^@]+)@[a-z0-9.-]+\.[a-z0-9.-]/i.exec(r.name);
    if (m) {
      r.name = m[1];
    }
    results.push(r);
  }
  return results;
};
